{
  "search-join-attendee-submit-btn": "完成",
  "go-to-package-btn": "购买选项",
  "done-exit-btn": "完成（离开自助机）",
  "title-select-package": "选择套装",
  "title-suggest-a-product": "您想为订单加购其他商品吗？",
  "title-choose-a-product": "选择要加入订单的商品",
  "store-title": "请选择您想购买的商品",
  "title-shopping-cart": "购物车",
  "select-images-notice-message": "请选择您要列印的图片。",
  "select-images-notice-ok": "确认",
  "confirm-change-img-btn": "确认，使用此图片",
  "select-image-title": "OCCO 个人照片",
  "welcome-title": "相册",
  "welcome-event-list-label": "活动清单:",
  "welcome-item-count-label": "项目数量:",
  "select-image-selection-title": "选择（{{count}}）张图片",
  "select-image-step-label": "步骤 {{currentStep}} / {{totalSteps}}",
  "select-image-for-product-text": "用于「{{title}}」",
  "select-image-next-btn": "下一步（{{selectedCount}}/{{requiredCount}}）",
  "select-image-clear-btn": "清除",
  "select-image-no-photos-message": "没有可用照片",
  "select-image-no-uid-message": "糟糕，找不到您的帐户。请再试一次。",
  "select-image-unlock-notice-message": "请选择您要解锁的图片。",
  "select-image-print-or-unlock-notice-message": "请选择您要列印或解锁的图片。",
  "select-image-addon-selection-title": "选择图片",
  "select-image-addon-done-count-btn": "完成（{{count}}）",
  "select-image-no-compatible-image-message": "找不到相容的图片",
  "select-image-photo-limit-message": "请选择 {{count}} 张要列印的图片。",
  "welcome-gallery-title": "我的相册",
  "welcome-select-images-of-yourself-title": "选择所有您的照片",
  "welcome-select-found-images-title": "选择要加入相册的照片",
  "welcome-back-to-gallery-btn": "返回相册",
  "checkout-subtotal-label": "小计:",
  "checkout-taxes-label": "税金:",
  "checkout-total-label": "总计:",
  "checkout-btn": "结账",
  "checkout-add-on-btn": "+ 加购",
  "checkout-add-product-btn": "新增商品",
  "checkout-empty-cart-message": "购物车是空的",
  "checkout-promo-code-placeholder": "仅供员工使用",
  "checkout-invalid-promo-code-message": "无效或已过期的优惠码！",
  "checkout-discount-label": "折扣: {{title}}",
  "checkout-receipt-title": "收据",
  "checkout-receipt-product-label": "商品",
  "checkout-receipt-unit-price-label": "单价",
  "checkout-receipt-qty-label": "数量",
  "checkout-receipt-amount-label": "金额",
  "checkout-digital-package-upsell-message": "要将<br>数位套装加入<br>购物车，并取得<br>所有数位内容的访问权限吗？",
  "photo-plus-pass-required-message": "您似乎尚未拥有 Photo+ Pass。<br><br>立即购买即可访问高解析度内容。",
  "photo-plus-valid-ticket-required-message": "您目前似乎尚未有本次园区行程的有效门票。请先链接门票，以享受 Photo+ 体验。",
  "photo-plus-visit-availability-message": "您的 Photo+ 体验仅在造访 Genting SkyWorlds 期间可用。",
  "checkout-other-products-upsell-message": "要为您的数位套装加购打印吗？",
  "checkout-delete-restriction-message": "若要购买加购项目，购物车中必须至少保留一个套装。若要更换套装，请先移除所有加购项目。",
  "checkout-digital-package-duplicate-message": "您的购物车中已有数位访问套装。<br>在移除或购买目前套装之前，无法新增新套装。",
  "welcome-print-modal-title": "列印",
  "welcome-print-modal-text": "您的照片将会列印并交付给活动主办方。",
  "cancel-btn": "取消",
  "welcome-preview-modal-title": "预览",
  "close-btn": "关闭",
  "ok-btn": "确认",
  "back-btn": "返回",
  "info-title": "资讯",
  "apply-btn": "套用",
  "clear-btn": "清除",
  "yes-btn": "是",
  "no-btn": "否",
  "change-image-btn": "更换图片",
  "done-btn": "完成",
  "skip-btn": "跳过",
  "refresh-btn": "刷新",
  "exit-btn": "离开",
  "unsupported-picture-format-message": "无效或不支持的图片格式",
  "welcome-alert-modal-title": "对话框标题",
  "welcome-alert-modal-body-text": "对话框内容显示于此。",
  "welcome-alert-save-btn": "储存变更",
  "welcome-passcodes-modal-title": "产生通行码",
  "welcome-passcodes-events-label": "请选择要产生通行码的活动：",
  "welcome-passcodes-email-label": "接收 XLS 格式通行码的电子邮件地址：",
  "welcome-passcodes-count-label": "要产生的通行码数量：",
  "welcome-passcodes-count-help": "介于 1-200,000 的数字",
  "welcome-passcodes-prepaid-label": "这些卡片持有人是否视为预付 / VIP？：",
  "welcome-passcodes-expiry-label": "公开自助机访问到期时间（分钟）（输入 0 以停用）：",
  "welcome-passcodes-url-prefix-label": "相册访问 URL 前缀（例如 https://domain-name.com）：",
  "welcome-passcodes-generate-btn": "产生",
  "sharing-modal-title": "分享图片",
  "sharing-tab-email": "Email",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "全名",
  "sharing-email-placeholder": "有效电子邮件地址",
  "sharing-email-help-text": "多个电子邮件地址可用分号、逗号、空格或 Enter 键分隔。",
  "sharing-contact-phone-placeholder": "电话号码",
  "sharing-company-placeholder": "公司 / 机构",
  "sharing-sms-name-placeholder": "全名",
  "sharing-sms-phone-placeholder": "有效电话号码",
  "sharing-privacy-link": "隐私政策",
  "sharing-privacy-prefix": "我们非常重视您的隐私，请阅读我们的",
  "welcome-delete-modal-title": "删除",
  "welcome-delete-modal-body": "确定要从相册删除此图片吗？",
  "welcome-delete-photo-confirmation-message": "您确定要从相册删除此图片吗？",
  "welcome-delete-photo-keep-btn": "保留这张图片！",
  "welcome-delete-photo-delete-btn": "从我的相册删除此图片",
  "welcome-delete-reason-not-mine-btn": "是。这不是我的图片",
  "welcome-delete-confirm-btn": "删除",
  "welcome-selfie-modal-title": "以人脸搜寻我的图片",
  "welcome-selfie-match-found-title": "我们可能找到您了！",
  "welcome-selfie-match-found-confirm-message": "点击您的图片以确认。",
  "welcome-selfie-capture-btn": "点此",
  "welcome-delete-reason-dont-want-btn": "是。这是我的图片，但我不想要",
  "welcome-print-copy-count-label": "选择列印份数",
  "catalog-select-product-package-title": "选择商品套装",
  "freedompay-offline-request-title": "请输入离线交易请求 ID",
  "square-reader-access-token-title": "请输入 Square Access Token",
  "square-reader-pairing-code-title": "请使用此代码登入新的 Square reader，完成后按确认。",
  "square-reader-still-unpaired-text": "此设备尚未配对，请使用代码登入新的 Square reader。",
  "square-reader-security-note-title": "基于安全原因，以下两组金钥不会被储存，请先记录",
  "storicard-invalid-code-text": "无效的 StoriCard 代码。",
  "header-menu-user-id-link": "UserID:",
  "countdown-time-up-text": "时间到！",
  "welcome-find-more-images-btn": "寻找更多图片",
  "welcome-select-images-btn": "选择图片",
  "welcome-selected-images-next-btn": "这 {{count}} 张图片中的是我，下一步 >",
  "welcome-invalid-attendee-id-message": "无效的 attendee ID。",
  "welcome-kiosk-time-expired-message": "抱歉，公开自助机使用时间已到",
  "welcome-grouping-error-message": "不允许合併 3 天前建立的帐户。",
  "confirm-btn": "确认",
  "approved-btn": "已核准",
  "checkout-confirm-purchase-title": "请确认您的购买",
  "checkout-confirm-purchase-short-title": "确认购买",
  "checkout-digital-access-summary": "访问您今天拍摄的所有数位图片",
  "checkout-and-text": "及",
  "checkout-print-count-summary": "{{count}} 份列印",
  "checkout-digitals-copy-message": "您要备份一份数位内容吗？<br>以防卡片遗失。",
  "checkout-email-placeholder": "您的电子邮件",
  "checkout-email-or-phone-placeholder": "您的电子邮件或美国电话号码",
  "checkout-sms-agreement-label": "我同意接收来自 Storibox 的通知讯息至上方提供的电话号码。我明白我将收到包含更新与图片链接的 SMS 讯息。可能会产生数据及讯息费用。如要取消，请回覆 STOP。",
  "checkout-name-placeholder": "您的姓名",
  "checkout-cancel-transaction-btn": "取消交易",
  "checkout-employee-authorization-title": "需要员工授权",
  "checkout-scan-employee-card-prefix": "交易完成时请扫描员工卡：",
  "checkout-transaction-complete-suffix": "已完成",
  "checkout-unlock-code-error-message": "员工授权码无效。",
  "checkout-printing-now-title": "正在列印",
  "checkout-prints-ready-message": "您的打印品将于一分钟内完成",
  "checkout-digitals-unlocked-message": "您的数位照片已解锁",
  "checkout-internal-error-title": "抱歉，系统内部错误",
  "checkout-transaction-processed-title": "交易已完成！",
  "checkout-register-receipt-qr-message": "请扫描 QR 以注册您的电子邮件，接收电子收据与相册链接！",
  "checkout-shop-more-btn": "继续选购",
  "checkout-print-receipt-btn": "列印收据",
  "checkout-paid-by-cash-label": "现金付款",
  "checkout-paid-by-card-label": "刷卡付款",
  "checkout-draft-order-error-message": "建立草稿订单失败。",
  "checkout-print-confirmation-message": "若您有订购打印品，将于一分钟内准備完成。您可于零售柜台领取商品",
  "checkout-shopify-params-incomplete-message": "Shopify 参数不完整",
  "checkout-event-name-required-message": "未提供 eventName。",
  "payment-no-device-connected-message": "未连接任何设备。",
  "payment-ask-for-assistance-message": "请寻求工作人员协助。",
  "payment-square-checkout-creation-failed-message": "建立结账请求失败。请稍后再试。",
  "payment-square-checkout-status-check-failed-message": "检查结账状态失败。请稍后再试。",
  "payment-qr-title": "使用手机付款",
  "payment-qr-help-html": "<b>快速且方便：</b><br> 扫描上方 QR code，并按照画面指示操作。",
  "payment-qr-transaction-progress-message": "交易进行中...",
  "payment-qr-failed-message": "QR 付款失败。请检查 API key 后重试。",
  "payment-failed-message": "付款失败。请稍后再试。",
  "payment-failed-short-message": "您的付款失败。",
  "payment-use-pinpad-message": "请使用 PinPad 完成交易...",
  "payment-terminal-progress-message": "交易处理中。<br>若要取消，请点选終端机上的箭头。",
  "payment-transaction-canceled-message": "您的交易已取消。",
  "search-version-label": "kiosk v.{{version}}",
  "search-find-by-qr-btn": "以 QR 搜寻",
  "search-find-by-face-btn": "以人脸搜寻",
  "search-scan-another-qr-placeholder": "扫描另一个 QR code",
  "search-scanned-attendee-label": "已扫描：{{attId}}",
  "search-qr-or-photos-not-found-message": "找不到 QR code 或照片。请重新扫描。",
  "scanning-qr-page-title": "相册",
  "photo-viewer-back-btn": "返回相册"
}
